import type { RouteRecordRaw } from 'vue-router';
import mainLayout from '@/layouts/MainLayout.vue';
import loginLayout from '@/layouts/LoginLayout.vue';
import indexPage from '@/pages/IndexPage.vue';
import settingsPage from '@/pages/SettingsPage.vue';
import TFAPage from '@/pages/TFAPage.vue';
import loginPage from '@/pages/LoginPage.vue';
import logoutPage from '@/pages/LoggedOutPage.vue';
import error404Page from '@/pages/ErrorNotFound.vue';

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'root',
    component: mainLayout,
    meta: {
      requiresAuth: true,
      visible: true,
    },
    children: [
      {
        path: '/',
        name: 'home',
        component: indexPage,
        meta: {
          visible: true,
        },
      },
      {
        path: '/settings',
        name: 'settings',
        component: settingsPage,
        meta: {
          visible: false,
        },
      },
      {
        path: '/tfa',
        name: 'tfa',
        component: TFAPage,
        meta: {
          visible: false,
        },
      },
    ]
  },
  {
    path: '/',
    name: 'root-login',
    component: loginLayout,
    meta: {
      requiresAuth: false,
    },
    children: [
      {
        path: '/login',
        name: 'login',
        component: loginPage
      },
      {
        path: '/logged-out',
        name: 'logged-out',
        component: logoutPage
      },
    ],
  },
  {
    path: '/:catchAll(.*)*',
    component: error404Page,
  },
];

export default routes;
